import {PaymentDistributionSchema} from "./payment-distribution-schema";

export class SelectedPaymentDistribution {
  schema: PaymentDistributionSchema;
}
